import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { connect } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";
import { Box, Button, Grid, IconButton, Typography } from "@material-ui/core";

import { login } from "../../../reducers/auth/thunks";
import { Input, Loading } from "../../common";
import { useForm } from "../../common/controls/useForm";
import {
  AuthContainer,
  LoginCard,
  LoginContent,
  useStyles,
  ForgotPassText,
  VerifiedEmailMessage,
} from "../styles";
import { AuthTypes } from "../../../reducers/auth/types";
import ForgotPassword from "../ForgotPassword";
import EmailVerificationSent from "../EmailVerificationSent";
import useQuery from "../../../hooks/useQuery";

const Login = ({
  login,
  loading,
  error,
  isAuthenticated,
  openForgotModal,
  closeForgotModal,
  forgotModalOpened,
}) => {
  const { state, handleChange } = useForm({ email: "", password: "" });
  const classes = useStyles();
  const location = useLocation();
  const params = useQuery();
  const [paramsState, setParamsState] = useState({ ...params });

  const handleSubmit = (e) => {
    e.preventDefault();
    login(state.email, state.password);
  };

  const handleParamsState = (k, v) => {
    setParamsState((state) => ({
      ...state,
      [k]: v,
    }));
  };
  const { redirectUrl } = location.state || {
    redirectUrl: { pathname: "/" },
  };

  const handleForgotClick = () => {
    if (forgotModalOpened) closeForgotModal();
    else openForgotModal();
  };

  if (isAuthenticated) {
    return <Redirect to={redirectUrl} />;
  }

  return (
    <>
      <ForgotPassword />
      <EmailVerificationSent email={state.email} />
      <AuthContainer>
        {paramsState.email_verified && (
          <VerifiedEmailMessage>
            <Typography variant="subtitle2" component="h4">
              Your email has been verified. Please input your credentials to
              sign in.
            </Typography>
            <IconButton
              className={classes.icoButton}
              onClick={(e) => handleParamsState("email_verified", false)}
            >
              <FaTimes />
            </IconButton>
          </VerifiedEmailMessage>
        )}
        <LoginCard>
          <LoginContent onSubmit={handleSubmit}>
            {error && (
              <Box p={1}>
                <Typography
                  paragraph
                  style={{
                    color: "var(--red-90)",
                    fontWeight: 600,
                  }}
                  variant="subtitle2"
                  component="h4"
                >
                  {error}
                </Typography>
              </Box>
            )}
            <Grid container direction="column" spacing={3}>
              <Grid item>
                <Input
                  name="email"
                  value={state.email}
                  onChange={handleChange}
                  type="email"
                  label="Email"
                  placeholder="Enter your email"
                  required
                />
              </Grid>
              <Grid item>
                <Input
                  name="password"
                  type="password"
                  label="Password"
                  value={state.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  required
                />
              </Grid>
              <Grid item>
                <ForgotPassText onClick={handleForgotClick}>
                  Forgot Password ?
                </ForgotPassText>
              </Grid>
              <Grid item>
                <Button className={classes.button} type="submit">
                  Login
                </Button>
              </Grid>
            </Grid>
          </LoginContent>
        </LoginCard>
      </AuthContainer>
      <Loading backdrop loading={loading} />
    </>
  );
};

const mapState = (state) => ({
  error: state.auth.error,
  isAuthenticated: state.auth.isAuthenticated,
  forgotModalOpened: state.auth.isForgotPassModalOpened,
  loading: state.auth.loading,
});

const mapDispatch = (dispatch) => ({
  login: (email, password) => dispatch(login({ email, password })),
  openForgotModal: () => dispatch({ type: AuthTypes.OPEN_FORGOT_PASS }),
  closeForgotModal: () => dispatch({ type: AuthTypes.CLOSE_FORGOT_PASS }),
});

export default connect(mapState, mapDispatch)(Login);
